import { Directive, ViewContainerRef, ComponentRef, Input, ChangeDetectionStrategy, Component, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Errors } from '../enums/errors.enum';

@Directive({
  selector: '[formControlName]'
})
export class FormErrorDirective {

  private ref: ComponentRef<ErrorComponent> | undefined;

  constructor(
    private el: ElementRef,
    private controlDir: NgControl,
    private vcr: ViewContainerRef,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.controlDir?.control) {
      this.controlDir.control.statusChanges.subscribe(() => {
        setTimeout(() => {
          if ((this.controlDir.control as any).touched) {
            this.setAndControlErrors(this.controlDir.control);
          }
        });
      });
      this.translate.onLangChange.subscribe(() => {
        setTimeout(() => {
          if ((this.controlDir.control as any).touched) {
            this.setAndControlErrors(this.controlDir.control);
          }
        });
      });
      (this.el.nativeElement as HTMLElement)?.addEventListener('blur', () => {
        setTimeout(() => {
          this.setAndControlErrors(this.controlDir.control);
        });
      });
    }
  }

  setAndControlErrors(control: AbstractControl | null) {
    setTimeout(() => {
      if (control?.errors) {
        let key = Object.keys(control.errors)[0];

        if (key === 'custom') {
          this.setError(control.errors[key]);
        } else {
          const keyIndex = Object.keys(Errors).indexOf(key);
          this.setError(this.translate.instant(Object.values(Errors)[keyIndex] as string, control.errors));
        }

      } else {
        this.setError(null);
      }
    });
  }

  setError(text: string | null) {
    if (!this.ref) {
      this.ref = this.vcr.createComponent(ErrorComponent);
    }
    this.ref.instance.text = text;
  }

}

@Component({
  template: `<p>{{_text}}</p>`,
  styles: [
    `p {
      color: #B30D05;
      position: absolute;
      bottom: -2.2em;
      left: 0.5em;
    }
    p:empty {
      display: none;
    }`
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent {

  _text: any;

  @Input() set text(value: any) {
    if (value !== this._text) {
      this._text = value;
      this.cdr.detectChanges();
    }
  };

  constructor(private cdr: ChangeDetectorRef) { }

}
